import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api/stcOrigin'
import * as stepApi from '../api/stcStep'
import * as ActionTypes from '../constants/actionTypes'
import * as API from '../constants/api'

export const stcTopicCreate = createAsyncThunk(
  ActionTypes.STC_TOPIC_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.STC_TOPIC}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.stcTopicCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcTopicDelete = createAsyncThunk(
  ActionTypes.STC_TOPIC_DELETE,
  async (params: PayloadCreatorParams<`/${typeof API.STC_TOPIC}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.stcTopicDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcTopicList = createAsyncThunk(
  ActionTypes.STC_TOPIC_LIST,
  async (params: PayloadCreatorParams<`/${typeof API.STC_TOPIC}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcTopicList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcTopicAll = createAsyncThunk(
  ActionTypes.STC_TOPIC_ALL,
  async (params: PayloadCreatorParams<`/${typeof API.STC_TOPIC_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcTopicAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcTopic = createAsyncThunk(
  ActionTypes.STC_TOPIC,
  async (params: PayloadCreatorParams<`/${typeof API.STC_TOPIC}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcTopic(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcChapter = createAsyncThunk(
  ActionTypes.STC_CHAPTER,
  async (params: PayloadCreatorParams<`/${typeof API.STC_CHAPTER}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcChapter(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcChapterList = createAsyncThunk(
  ActionTypes.STC_CHAPTER_LIST,
  async (params: PayloadCreatorParams<`/${typeof API.STC_CHAPTER}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcChapterList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcChapterAll = createAsyncThunk(
  ActionTypes.STC_CHAPTER_ALL,
  async (params: PayloadCreatorParams<`/${typeof API.STC_CHAPTER_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcChapterAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcChapterAllClear = createAction(`${ActionTypes.STC_CHAPTER_ALL}/clear`)

export const stcChapterDelete = createAsyncThunk(
  ActionTypes.STC_CHAPTER_DELETE,
  async (params: PayloadCreatorParams<`/${typeof API.STC_CHAPTER}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.stcChapterDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcChapterCreate = createAsyncThunk(
  ActionTypes.STC_CHAPTER_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.STC_CHAPTER}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.stcChapterCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcChapterCreateBatch = createAsyncThunk(
  ActionTypes.STC_CHAPTER_CREATE_BATCH,
  async (params: PayloadCreatorParams<`/${typeof API.STC_CHAPTER_CREATE_BATCH}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.stcChapterCreateBatch(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcAdmin = createAsyncThunk(
  ActionTypes.STC_ADMIN,
  async (params: PayloadCreatorParams<`/${typeof API.STC_ADMIN}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcAdmin(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcAction = createAsyncThunk(
  ActionTypes.STC,
  async (params: PayloadCreatorParams<`/${typeof API.STC}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stc(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcListAction = createAsyncThunk(
  ActionTypes.STC_LIST,
  async (params: PayloadCreatorParams<`/${typeof API.STC}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcAllAction = createAsyncThunk(
  ActionTypes.STC_ALL,
  async (params: PayloadCreatorParams<`/${typeof API.STC_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcCreateAction = createAsyncThunk(
  ActionTypes.STC_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.STC}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.stcCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcCategoryAction = createAsyncThunk(
  ActionTypes.STC_CATEGORY,
  async (params: PayloadCreatorParams<'/stc/category/{id}', 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcCategory(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcCategoryAllAction = createAsyncThunk(
  ActionTypes.STC_CATEGORY_ALL,
  async (params: PayloadCreatorParams<`/${typeof API.STC_CATEGORY_ALL}`, 'get'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.stcCategoryAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcCategoryListAction = createAsyncThunk(
  ActionTypes.STC_CATEGORY_LIST,
  async (params: PayloadCreatorParams<`/${typeof API.STC_CATEGORY}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.stcCategoryList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcCategoryCreateAction = createAsyncThunk(
  ActionTypes.STC_CATEGORY_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.STC_CATEGORY}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.stcCategoryCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcCategoryDelete = createAsyncThunk(
  ActionTypes.STC_CATEGORY_DELETE,
  async (params: PayloadCreatorParams<`/${typeof API.STC_CATEGORY}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.stcCategoryDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcStepAction = createAsyncThunk(
  ActionTypes.STC_STEP,
  async (params: PayloadCreatorParams<`/${typeof API.STC_STEP}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await stepApi.stcStep(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcStepAdminAll = createAsyncThunk(
  ActionTypes.STC_STEP_ADMIN_ALL,
  async (params: PayloadCreatorParams<`/${typeof API.STC_STEP_ADMIN_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await stepApi.stcStepAdminAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcStepAllAction = createAsyncThunk(
  ActionTypes.STC_STEP_ALL,
  async (params: PayloadCreatorParams<`/${typeof API.STC_STEP_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await stepApi.stcStepAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcStepListAction = createAsyncThunk(
  ActionTypes.STC_STEP_LIST,
  async (params: PayloadCreatorParams<`/${typeof API.STC_STEP}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await stepApi.stcStepList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcStepCreateAction = createAsyncThunk(
  ActionTypes.STC_STEP_CREATE,
  async (params: PayloadCreatorParams<`/${typeof API.STC_STEP}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await stepApi.stcStepCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const stcStepCompleteAction = createAsyncThunk(
  ActionTypes.STC_STEP_COMPLETE,
  async (params: PayloadCreatorParams<`/${typeof API.STC_STEP_COMPLETE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await stepApi.stcStepComplete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)
export const stcStepAdminAllClear = createAction(`${ActionTypes.STC_STEP_ADMIN_ALL}/clear`)
export const stcAllClear = createAction(`${ActionTypes.STC_ALL}/clear`)
export const stcAdminClear = createAction(`${ActionTypes.STC_ADMIN}/clear`)
